import { BootstrapServiceBase } from '../bootstrap.service.base';
var IntroPageComponent = /** @class */ (function () {
    function IntroPageComponent(bootstrapService) {
        this.bootstrapService = bootstrapService;
    }
    return IntroPageComponent;
}());
export { IntroPageComponent };
